import { render, staticRenderFns } from "./AddPermissionsDialog.vue?vue&type=template&id=210e81a0"
import script from "./AddPermissionsDialog.vue?vue&type=script&lang=js"
export * from "./AddPermissionsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports